import styled from "styled-components";

import { Block } from "./Block";

export const LinkBlock = styled(Block)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding: 1em 2em 1em 1em;
    margin: 0;
    position: relative;
    cursor: pointer;
`;
